import { ListingKind, PublicListing } from '@kouto/types';
import { NormalizedPublicListing } from 'types/listingV3';

const normalizeListingV1 = (
  listing: PublicListing,
): NormalizedPublicListing => {
  return {
    bookingAvailabilityMode: listing.bookingAvailabilityMode,
    brandId: listing.brandId,
    categoryId: listing.category?.id ?? undefined,
    categoryName: listing.category?.name ?? undefined,
    dates: listing.dates ? listing.dates.map((date) => new Date(date)) : [],
    experienceId:
      listing.kind === ListingKind.EXPERIENCE ? listing.id : undefined, // listing.id is either experienceId or resourceGroupCollectionId
    hidePrice: listing.hidePrice,
    hostedBy: listing.hostedBy?.id
      ? {
          id: listing.hostedBy?.id,
          firstName: listing.hostedBy?.firstName,
          lastName: listing.hostedBy?.lastName,
          description: listing.hostedBy?.description,
          profilePicture: listing.hostedBy?.profilePicture,
        }
      : null,
    id: listing.listingId ?? '', // listingId is nullable for v1 listings :(
    isExclusive: listing.isExclusive,
    kind: listing.kind,
    maxParticipants: listing.defaultMaxParticipantCount,
    medias: listing.medias,
    pointsEligible: null,
    productLine: listing.productLine,
    promotedListing: null,
    rating: listing.ratings.rating,
    resourceGroupCollectionId:
      listing.kind !== ListingKind.EXPERIENCE ? listing.id : undefined,
    resourceGroups: listing.resourceGroups
      ? listing.resourceGroups.map((rg) => ({
          ...rg,
          resourceGroupCollectionId: listing.id,
        }))
      : [],
    advertisedPrice: null,
    slug: listing.slug,
    startingPrice: listing.defaultPriceTiers[0]?.price ?? null,
    summary: listing.description,
    title: listing.title,
    vibes: listing.vibes.map((vibe) => ({
      id: vibe.id,
      brandId: listing.brandId,
      name: vibe.name,
    })),
  };
};

export default normalizeListingV1;
